/**
 * 充值逻辑 Hook（精简自 H5 src/composables/payment/composables/usePurchase.ts）
 */
import { computed, ref } from 'vue'
import { PRODUCT_LIST_API } from './constants'
import {
  createAvailablePaymentMethods,
  createSelectPaymentMethod,
  getPayType,
  getPaymentChannelName,
  getTopupPaymentApi,
  initializePaymentMethod,
} from './paymentUtils'
import { api } from '@/api'

export interface PurchaseBook {
  contentId?: string
  contentChapterId?: string
  bookName?: string
  chapterName?: string
}

export function usePurchase(book?: PurchaseBook) {
  const loading = ref(false)
  const payLoading = ref(false)
  const productLists = ref<any[]>([])
  const currentPaymentMethod = ref<number>(3) // 默认 PayPal
  const hasPayPalPasswordlessPayment = ref(false)
  const hasPlacedOrder = ref(false)

  const availablePaymentMethods = computed(createAvailablePaymentMethods(
    productLists,
    hasPayPalPasswordlessPayment,
    hasPlacedOrder,
  ))

  const templateProducts = computed(() => {
    const currentMethod = Number(currentPaymentMethod.value)
    const productList = availablePaymentMethods.value.find(
      (list: any) => Number(list.paymentMethod) === currentMethod,
    )
    if (!productList?.products)
      return []
    return productList.products
  })

  const selectPaymentMethod = createSelectPaymentMethod(currentPaymentMethod)

  async function fetchProducts() {
    loading.value = true
    try {
      const res: any = await api.get(PRODUCT_LIST_API.TOPUP, {
        params: {
          type: book?.contentId ? 1 : 2,
          contentId: book?.contentId || '',
          contentChapterId: book?.contentChapterId || '',
        },
      })
      if (res.data && typeof res.data === 'object') {
        hasPayPalPasswordlessPayment.value = res.data.hasPayPalPasswordlessPayment || false
        hasPlacedOrder.value = res.data.hasPlacedOrder || false
        productLists.value = res.data.productLists || []
        initializePaymentMethod(currentPaymentMethod, productLists, hasPayPalPasswordlessPayment, hasPlacedOrder)
      }
    }
    catch {}
    loading.value = false
  }

  async function PayTemplate(item: any) {
    if (payLoading.value)
      return
    payLoading.value = true
    const redirectUrl = `${window.location.origin}/paying?redirect_source=${encodeURIComponent(window.location.href)}&paymentChannel=${getPaymentChannelName(currentPaymentMethod.value)}&axon_price=${item.price}&axon_product_id=${item.productId}`
    const params = {
      payConfigId: item.payConfigId,
      productId: item.productId,
      contentId: book?.contentId,
      contentChapterId: book?.contentChapterId,
      memberCurrencyCode: 'usd',
      payType: getPayType(currentPaymentMethod.value),
      type: book?.contentId ? 1 : 2,
      successUrl: `${redirectUrl}&payment_status=success`,
      cancelUrl: `${redirectUrl}&payment_status=cancel`,
    }
    try {
      const { data } = await api.post<any>(getTopupPaymentApi(currentPaymentMethod.value), params)
      if (data) {
        try {
          const _ = new URL(data)
          window.location.href = data
        }
        catch {
          window.location.reload()
        }
      }
      else {
        window.location.reload()
      }
    }
    catch {
      payLoading.value = false
    }
  }

  fetchProducts()

  return {
    loading,
    payLoading,
    templateProducts,
    availablePaymentMethods,
    currentPaymentMethod,
    selectPaymentMethod,
    productLists,
    hasPayPalPasswordlessPayment,
    PayTemplate,
  }
}
